import React from "react";
import "./style.css";
import worldImg from "./assets/dmt2.png";
import { FaRegLightbulb } from "react-icons/fa";

const DMTSection = () => {
  return (
    <>
      {/* ===== DMT Banner Section ===== */}
      <section className="dmt-banner">
        <div className="dmt-content">
          <h1 className="dmt-title">DMT - Domestic Money Transfer Services</h1>

          <p className="dmt-subtitle">
            Instant & Secure Domestic Transfers | Fast & Reliable DMT Solutions
          </p>
        </div>
      </section>

      {/* ===== Image Section ===== */}
      <section className="dmt-image-section">
        <img src={worldImg} alt="DMT World Map" className="dmt-world-img" />
      </section>

      {/* ===== Description Section ===== */}
      <section className="dmt-description">
        <p className="dmt-para">
          DMT (Domestic Money Transfer) services enable individuals to transfer
          money quickly and securely to any bank account within the country.
          With Omeswara’s advanced DMT platform, users can send funds
          instantly—even if they don’t have access to internet banking or a
          personal bank account. This makes Omeswara’s DMT services especially
          valuable for people in underserved or remote areas with limited
          banking facilities.
        </p>

        <p className="dmt-para">
          Businesses, retailers, and agents can use Omeswara’s DMT services to
          offer hassle-free cash deposits and transfers, ensuring greater
          financial inclusion for the unbanked population. Migrant workers,
          daily wage earners, and those needing urgent money transfers benefit
          immensely from this service. With secure processing, 24/7
          availability, and instant settlements, Omeswara DMT is a trusted
          solution for both personal and business transactions.
        </p>
      </section>

      {/* ===== Benefits Section ===== */}
      <section className="benefits-section">
        <h2 className="benefits-title">
          Benefits of Using Omeswar DMT Money Transfer Services
        </h2>

        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">
              <FaRegLightbulb />
            </div>
            <div className="benefit-text">
              <h3>No Need for Bank Visits</h3>
              <p>
                Customers can transfer money instantly without stepping into a
                bank. Omeswara ensures smooth, fast, and convenient DMT
                transfers anytime, anywhere.
              </p>
            </div>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">
              <FaRegLightbulb />
            </div>
            <div className="benefit-text">
              <h3>Works Without Internet Banking</h3>
              <p>
                No net banking? No issue. Omeswara’s DMT system allows users to
                send funds using simple beneficiary details—making digital
                transfers accessible to everyone.
              </p>
            </div>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">
              <FaRegLightbulb />
            </div>
            <div className="benefit-text">
              <h3>Supports All Major Banks</h3>
              <p>
                Our DMT platform is compatible with all leading banks across
                India, ensuring reliable and secure nationwide transfers.
              </p>
            </div>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">
              <FaRegLightbulb />
            </div>
            <div className="benefit-text">
              <h3>Safe & Fully Compliant</h3>
              <p>
                Omeswara DMT services follow strict security and compliance
                standards, protecting user data and ensuring fraud-free
                transactions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Why Choose Section ===== */}
      <section className="why-section">
        <h2 className="why-title">
          Why Choose Our Domestic Money Transfer Services?
        </h2>

        <div className="why-grid">
          <div className="why-card">
            <h3>Instant Fund Transfers</h3>
            <p>
              Send money instantly across India with Omeswara’s fast DMT
              processing. Enjoy smooth, hassle-free transactions with minimal
              waiting time.
            </p>
          </div>

          <div className="why-card">
            <h3>Secure Transactions</h3>
            <p>
              Your transfers are protected with advanced encryption and
              multi-layer security technologies—ensuring complete safety for
              every transaction
            </p>
          </div>

          <div className="why-card">
            <h3>24/7 Availability</h3>
            <p>
              Omeswara DMT services operate round the clock, enabling users to
              transfer funds anytime—even during bank holidays.
            </p>
          </div>

          <div className="why-card">
            <h3>No Bank Account Needed</h3>
            <p>
              Users without a personal bank account can still transfer money
              through authorized Omeswara agents—making financial services
              accessible to all.
            </p>
          </div>

          <div className="why-card">
            <h3>Low Service Charges</h3>
            <p>
              Enjoy cost-effective money transfers with low service fees, making
              Omeswara one of the most affordable DMT solutions in the industry.
            </p>
          </div>
        </div>
      </section>

      {/* ============================================== */}
      {/* ===== How Our DMT Money Transfer Works ===== */}
      {/* ============================================== */}
      <section className="process-section">
        <h2 className="process-title">How Our DMT Money Transfer Works?</h2>

        <div className="process-grid">
          <div className="process-card">
            <h3>Register/Login</h3>
            <p>Access the Omeswara DMT portal or merchant dashboard.</p>
          </div>

          <div className="process-card">
            <h3>Enter Beneficiary Details</h3>
            <p>
              Add recipient information such as name, account number, and IFSC.
            </p>
          </div>

          <div className="process-card">
            <h3>Transfer Funds</h3>
            <p>Send money instantly through secure and reliable processing.</p>
          </div>

          <div className="process-card">
            <h3>Receive Instant Confirmation</h3>
            <p>
              Both sender and receiver get quick confirmation for every
              completed transaction.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default DMTSection;
